export class UserRolesAndPermissionDto {
  id: number;
  clientId: string;
  roles: string[];
  clientName: string;
  permissions: string[];
}
